const MODAL_ACTIVE_CLASS = 'modal-active';

export const toggleModal = () => {
    const bodyClassList = document.body.classList;

    if (bodyClassList.contains(MODAL_ACTIVE_CLASS)) {
        bodyClassList.remove(MODAL_ACTIVE_CLASS);
    } else {
        bodyClassList.add(MODAL_ACTIVE_CLASS);
    }
};
